import React, { useEffect, useState } from "react";
import ShiftStream from "../..";

import Table from "./Table";
import Pagination from "../../components/pagination";

import { useWarnings } from "./graphql/use-warnings";
import { FooterControls, PaginationSlot } from "../styles";

export const COL_WIDTHS = [
  "6vw",
  "8vw",
  "15vw",
  "8vw",
  "16vw",
  "12vw",
  "16vw",
  "6vw"
];

export const Warnings = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const { warnings, totalPages, loading } = useWarnings(currentPage);

  useEffect(() => {
    if (!loading && currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages, loading]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);

    const scrollBody = document.querySelector(".streams-table-scroll-body");
    if (scrollBody instanceof HTMLElement) {
      scrollBody.scrollTo({ top: 0, behavior: "auto" });
    }
  };

  return (
    <ShiftStream>
      <Table warnings={warnings} loading={loading} />

      <FooterControls>
        <PaginationSlot>
          <Pagination
            page={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            disabled={loading}
          />
        </PaginationSlot>
      </FooterControls>
    </ShiftStream>
  );
};
